module.exports = __webpack_public_path__ + "img/LPN_Sword_Cyber_Magma.c5e35806.png";